"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var theme = {
  colors: {
    white: "#fff",
    lightblue: "#82b4ff",
    dark: "#1f1f1f",
    gray: "#333333",
    buttonColor: {
      orange: "#ffb800",
      deepOrange: "#ff6b18",
      blue: "#1890ff",
      green: "#4caf50",
      yellow: "#ffec43",
      red: "#ff4d4f",
      gray: "#B0B0B0"
    }
  },
  background: {
    buttonColor: {
      orange: "#ffb800",
      deepOrange: "#ff6b18",
      blue: "#1890ff",
      green: "#4caf50",
      yellow: "#ffec43",
      red: "#ff4d4f",
      white: "#fff",
      gray: "#B0B0B0"
    }
  },
  borderColor: {
    buttonColor: {
      orange: "#ffb800",
      deepOrange: "#ff6b18",
      blue: "#1890ff",
      green: "#4caf50",
      yellow: "#ffec43",
      red: "#ff4d4f",
      white: "#fff",
      gray: "#B0B0B0"
    }
  }
};

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, children);
};

ThemeProvider.propTypes = {
  children: _propTypes.default.element
};
var _default = ThemeProvider;
exports.default = _default;